module.exports = __webpack_public_path__ + "img/atletico.e2494ba7.svg";